import Button from "../../toolkit/ButtonV1";
import PlusIcon from "../../icons/PlusIcon";
import { useNavigate } from "react-router-dom";

export default function TitlebarChildren() {
  const navigate = useNavigate();
  return (
    <Button
      label="Invite Vendor"
      leadingComponent={<PlusIcon />}
      size="small"
      onClick={() => {
        navigate("/InviteVendor")
      }}
    />
  );
}
